/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonial_1_NameInputs */

const en_landing_testimonial_1_name = /** @type {(inputs: Landing_Testimonial_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy-First`)
};

const de_landing_testimonial_1_name = /** @type {(inputs: Landing_Testimonial_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutz an erster Stelle`)
};

const fr_landing_testimonial_1_name = /** @type {(inputs: Landing_Testimonial_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vie privée d'abord`)
};

const es_landing_testimonial_1_name = /** @type {(inputs: Landing_Testimonial_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacidad primero`)
};

const it_landing_testimonial_1_name = /** @type {(inputs: Landing_Testimonial_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy al primo posto`)
};

const nl_landing_testimonial_1_name = /** @type {(inputs: Landing_Testimonial_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy-eerst`)
};

const pl_landing_testimonial_1_name = /** @type {(inputs: Landing_Testimonial_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prywatność przede wszystkim`)
};

const fi_landing_testimonial_1_name = /** @type {(inputs: Landing_Testimonial_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityisyys edellä`)
};

const da_landing_testimonial_1_name = /** @type {(inputs: Landing_Testimonial_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privatliv først`)
};

const sv_landing_testimonial_1_name = /** @type {(inputs: Landing_Testimonial_1_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integritet först`)
};

/**
* | output |
* | --- |
* | "Privacy-First" |
*
* @param {Landing_Testimonial_1_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonial_1_name = /** @type {((inputs?: Landing_Testimonial_1_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonial_1_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonial_1_name(inputs)
	if (locale === "fr") return fr_landing_testimonial_1_name(inputs)
	if (locale === "es") return es_landing_testimonial_1_name(inputs)
	if (locale === "it") return it_landing_testimonial_1_name(inputs)
	if (locale === "nl") return nl_landing_testimonial_1_name(inputs)
	if (locale === "pl") return pl_landing_testimonial_1_name(inputs)
	if (locale === "fi") return fi_landing_testimonial_1_name(inputs)
	if (locale === "da") return da_landing_testimonial_1_name(inputs)
	if (locale === "sv") return sv_landing_testimonial_1_name(inputs)
	return en_landing_testimonial_1_name(inputs)
});